import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ContractorFilters = ({ 
  searchQuery, 
  onSearchChange, 
  specialtyFilter, 
  onSpecialtyChange,
  availabilityFilter,
  onAvailabilityChange,
  ratingFilter,
  onRatingChange,
  resultCount 
}) => {
  const specialtyOptions = [
    { value: 'all', label: 'All Specialties' },
    { value: 'General Contractor', label: 'General Contractor' },
    { value: 'Electrician', label: 'Electrician' },
    { value: 'Plumber', label: 'Plumber' },
    { value: 'HVAC Specialist', label: 'HVAC Specialist' },
    { value: 'Foundation Specialist', label: 'Foundation Specialist' },
    { value: 'Framing Specialist', label: 'Framing Specialist' }
  ];

  const availabilityOptions = [
    { value: 'all', label: 'All Availability' },
    { value: 'available', label: 'Available' },
    { value: 'busy', label: 'Busy' },
    { value: 'on_leave', label: 'On Leave' },
    { value: 'unavailable', label: 'Unavailable' }
  ];

  const ratingOptions = [
    { value: 'all', label: 'All Ratings' },
    { value: '4+', label: '4+ Stars' },
    { value: '3+', label: '3+ Stars' },
    { value: '<3', label: 'Below 3 Stars' }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-sm mb-4 md:mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="relative">
          <Input
            type="search"
            placeholder="Search contractors..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="pl-10"
          />
          <Icon 
            name="Search" 
            size={18} 
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
          />
        </div>

        <Select
          placeholder="Filter by specialty"
          options={specialtyOptions}
          value={specialtyFilter}
          onChange={onSpecialtyChange}
        />

        <Select
          placeholder="Filter by availability"
          options={availabilityOptions}
          value={availabilityFilter}
          onChange={onAvailabilityChange}
        />

        <Select
          placeholder="Filter by rating"
          options={ratingOptions}
          value={ratingFilter}
          onChange={onRatingChange}
        />
      </div>
      <div className="mt-4 flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          Showing <span className="font-semibold text-foreground">{resultCount}</span> contractor{resultCount !== 1 ? 's' : ''}
        </p>
      </div>
    </div>
  );
};

export default ContractorFilters;